import { REPORTS_API } from "redux/api";

const generateQueryParams = (payload) => {
    let query = "";
    if(payload?.locationId){
        query+="&locationId="+payload?.locationId
    }else if(payload?.locationid){
        query+="&locationId="+payload?.locationid
    }

    if(payload?.startDate){
        query+="&startDate="+payload?.startDate
    }
    if(payload?.endDate){
        query+="&endDate="+payload?.endDate
    }

    if(payload?.tablePageNo){
        query+="&page="+payload?.tablePageNo
    }else if(payload?.page){
        query+="&page="+payload?.page
    }
    if(payload?.tableRecordLimit){
        query+="&size="+payload?.tableRecordLimit
    }else if(payload?.size){
        query+="&size="+payload?.size
    }
    if(payload?.searchQuery || payload?.searchQuery === ""){
        query+="&search="+payload?.searchQuery
    }else if(payload?.search || payload?.search === ""){
        query+="&search="+payload?.search
    }

    if (payload?.itemIds?.length > 0) {
        query += `&itemIds=${(payload?.itemIds || [])?.join(",")}`;
    } else if (payload?.categoryIds?.length > 0) {
        query += `&categoryIds=${(payload?.categoryIds || [])?.join(",")}`;
    }else if(payload?.groupByCategory){
        query+=`&groupByCategory=${payload?.groupByCategory}`
    }
    if(payload?.reason){
        query+=`&reason=${payload?.reason}`
    }
    if(payload?.offer){
        query+=`&offer=${payload?.offer}`
    }
    if(payload?.type){
        query+=`&type=${payload?.type}`
    }

    if(payload?.eventSlug || payload?.eventSlug === ""){
        query+=`&eventSlug=${payload?.eventSlug}`
    }

    if(payload?.eventDate){
        query+=`&eventDate=${payload?.eventDate}`
    }

    if(payload?.startTime){
        query+=`&startTime=${payload?.startTime}`
    }

    if(payload?.endTime){
        query+=`&endTime=${payload?.endTime}`
    }

    return "?"+query?.slice(1)
}

// Pre-order Summary
export const getPreOrderEventOverview = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/events/event-overview${query}`,
    });
};

export const getPreOrderByOrderDate = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/events/pre-order/order-date${query}`,
    });
};

export const getPreOrderByPickupSlot = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/events/pre-order/pickup${query}`,
    });
};

export const getPreOrdersByChannels = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/events/pre-order/channels${query}`,
    });
};

// Pre-order Details
export const getPreOrderDetails = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/events/pre-order/details${query}`,
    });
};

// Event Name Filter Values :
export const getEventNameFilterValues = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/events/event-name${query}`,
    });
};

// Event Time Slots Filter :
export const getEventTimeSlotsFilter = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/events/pre-order/slots${query}`,
    });
};
